<template>
    <div class="w-full md:w-8 lg:w-8 mb-5">
        <h3 class="Label mb-4 mt-5 text-left">Select your Date of Birth</h3>
        <DatePicker v-model="dob" dateFormat="dd/mm/yy" showIcon fluid iconDisplay="input"
            placeholder="Enter your date of birth here" class="w-full mb-4" variant="filled" size="small" />

        <div class="w-full mb-4">
            <NationalitySelect v-model="nationality" label="Select your nationality" placeholder="Choose your nationality" />
        </div>

        <h3 class="Label mb-4 text-left">Finally, tell us about your budget for a class? (Rs.)</h3>

        <div class="w-full px-2">
            <Slider
                v-model="selectedBudgetRange"
                :step="20"
                :min="500"
                :max="8000"
                range
                class="w-full mb-4"
                style="color: #a72e44; background-color: #a72e44; border-radius: 5px;"
            />

            <div class="flex justify-content-between w-full">
                <p class="text-sm m-0" style="color: #a72e44; font-weight: 600;">
                    Min: Rs. {{ budgetMinValue }}
                </p>
                <p class="text-sm m-0" style="color: #a72e44; font-weight: 600;">
                    Max: Rs. {{ budgetMaxValue }}
                </p>
            </div>
        </div>

        <Button label="Next" class="orange-button mt-6 w-full" @click="nextStep" />
    </div>
</template>

<script setup>
import { ref, defineEmits, computed } from 'vue';
import { Button, DatePicker, Slider } from 'primevue';
import { notifyWarn } from '@/utils/notification';
import { useAuthStore } from '@/stores/authStore';
import NationalitySelect from '@/components/common/NationalitySelect.vue';

const emit = defineEmits(["budget-selected"]);

const dob = ref(null);
const nationality = ref(null);

const selectedBudgetRange = ref([500, 8000]);
const authStore = useAuthStore();

const budgetMinValue = computed(() => selectedBudgetRange.value[0]);
const budgetMaxValue = computed(() => selectedBudgetRange.value[1]);

const nextStep = () => {
    if (!dob.value) {
        notifyWarn("Please select your date of birth");
        return;
    }

    if (!nationality.value) {
        notifyWarn("Please select your nationality");
        return;
    }

    if (!selectedBudgetRange.value || selectedBudgetRange.value.length < 2) {
        notifyWarn("Please select a valid budget range");
        return;
    }

    authStore.completeOnboarding();

    emit('budget-selected', {
        minValue: budgetMinValue.value,
        maxValue: budgetMaxValue.value,
        dateOfBirth: dob.value,
        nationality: nationality.value,
    });
};
</script>

<style scoped>
.flex {
    display: flex !important;
}
.justify-content-between {
    justify-content: space-between !important;
}
</style>